const PRIVACITY_LINK = process.env.PRIVACITY_LINK || "";
const TERMS_LINK = process.env.TERMS_LINK || "";

export { PRIVACITY_LINK, TERMS_LINK };
